(() => {
  if (window.bulloraLandingOrderLoaded) return;
  window.bulloraLandingOrderLoaded = true;
  const init = root => {
    if (root.dataset.orderReady) return;
    const form = root.querySelector('[data-order-form]');
    const configNode = root.querySelector('[data-order-config]');
    const startup = root.querySelector('[data-order-startup]');
    if (!form || !configNode) return;
    let config;
    try {
      config = JSON.parse(configNode.textContent);
      if (!config.productId || !config.currency || !config.messages || !config.checkoutLabel) throw Error('Invalid order configuration');
    } catch {
      if (startup) { startup.textContent = startup.dataset.failedMessage; startup.setAttribute('role', 'alert'); }
      return;
    }
    const choices = [...root.querySelectorAll('[data-order-choice]')];
    const kinds = ['tumbler', 'base', 'cap'];
    const messages = config.messages;
    const error = root.querySelector('[data-order-error]');
    const submit = root.querySelector('[data-order-submit]');
    const submitLabel = submit.querySelector('[data-order-submit-label]');
    const next = root.querySelector('[data-order-next]');
    const back = root.querySelector('[data-order-back]');
    const recover = root.querySelector('[data-order-recover]');
    const cartLink = root.querySelector('[data-order-cart-link]');
    const checkoutLink = root.querySelector('[data-order-confirmed-checkout]');
    const heading = root.querySelector('[data-order-heading]');
    const image = root.querySelector('.wlo-photo img');
    const imageError = root.querySelector('[data-order-image-error]');
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const storageKey = `bullora-landing-pending-${config.productId}`;
    const prices = root.closest('[data-wl-landing]').querySelectorAll('[data-order-total],[data-wl-order-price]');
    let step = 0;
    let busy = false;
    let uncertain = false;
    let pending = null;
    let maxReached = 0;
    let builderOpened = false;
    let disposed = false;
    const sentEvents = new Set();
    const eventQueue = new Map();
    const journeyId = globalThis.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    const environment = window.Shopify?.designMode || new URLSearchParams(location.search).has('preview_theme_id') || new URLSearchParams(location.search).has('bullora_preview') ? 'preview' : 'live';
    const flushEvents = () => {
      if (disposed) return;
      try {
        const privacy = window.Shopify?.customerPrivacy;
        if (typeof privacy?.analyticsProcessingAllowed !== 'function') return;
        if (!privacy.analyticsProcessingAllowed()) { eventQueue.clear(); return; }
        if (typeof window.Shopify?.analytics?.publish !== 'function') return;
        eventQueue.forEach((event, key) => {
          eventQueue.delete(key);
          if (sentEvents.has(key)) return;
          sentEvents.add(key);
          const result = window.Shopify.analytics.publish(event.name, event.payload);
          if (result?.catch) result.catch(() => {});
        });
      } catch {}
    };
    const track = (name, data = {}, onceKey) => {
      const key = onceKey || `${name}:${Date.now()}:${Math.random()}`;
      if (disposed || sentEvents.has(key) || eventQueue.has(key)) return;
      if (eventQueue.size >= 40) return;
      eventQueue.set(key, { name: `bullora:${name}`, payload: { schema_version: 1, funnel_version: '2026-10-26-v2', source: 'bullora_landing', environment, event_id: `${journeyId}:${key}`, journey_id: journeyId, product_id: config.productId, currency: config.currency, ...data } });
      flushEvents();
    };
    const openBuilder = () => {
      builderOpened = true;
      track('builder_opened', {}, 'opened');
      track('builder_step_viewed', { step: step + 1 }, `viewed:${step + 1}`);
    };
    const consentChanged = () => {
      flushEvents();
      const rect = root.getBoundingClientRect();
      if (rect.top < innerHeight * .8 && rect.bottom > 0) openBuilder();
    };
    document.addEventListener('visitorConsentCollected', consentChanged);
    if (!window.Shopify?.customerPrivacy && typeof window.Shopify?.loadFeatures === 'function') {
      try { window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], () => { if (!disposed) consentChanged(); }); } catch {}
    }
    let analyticsTicks = 0;
    const analyticsTimer = setInterval(() => { flushEvents(); if (++analyticsTicks >= 10) clearInterval(analyticsTimer); }, 1000);
    const selected = kind => choices.find(input => input.dataset.kind === kind && input.checked);
    const valid = kind => selected(kind)?.dataset.available === 'true';
    const validSet = () => kinds.every(valid);
    const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'hu-HU', { style: 'currency', currency: config.currency, minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(cents / 100);
    const localUrl = value => {
      const url = new URL(value, location.origin);
      if (url.origin !== location.origin) throw Error('Invalid cart origin');
      return url.href;
    };
    const urls = {};
    try { ['add', 'cart', 'change', 'checkout'].forEach(key => { urls[key] = localUrl(config[key]); }); } catch {
      if (startup) { startup.textContent = startup.dataset.failedMessage; startup.setAttribute('role', 'alert'); }
      track('builder_error', { code: 'invalid_configuration', step: 1 }, 'error:config');
      disposed = true;
      clearInterval(analyticsTimer);
      document.removeEventListener('visitorConsentCollected', consentChanged);
      return;
    }
    const request = async (url, options = {}) => {
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), options.method === 'POST' ? 20000 : 12000);
      try { return await fetch(url, { ...options, signal: controller.signal }); }
      finally { clearTimeout(timer); }
    };
    const showError = text => {
      error.textContent = text || '';
      error.hidden = !text;
    };
    const storePending = operation => {
      pending = operation;
      try {
        if (operation) sessionStorage.setItem(storageKey, JSON.stringify(operation));
        else sessionStorage.removeItem(storageKey);
      } catch {}
    };
    const updateImage = kind => {
      const input = selected(kind);
      if (!input || !image) return;
      if (input.dataset.image) {
        image.hidden = false;
        if (imageError) imageError.hidden = true;
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
        const rect = root.getBoundingClientRect();
        image.loading = rect.top < innerHeight && rect.bottom > 0 ? 'eager' : 'lazy';
        image.src = input.dataset.image;
        image.alt = input.dataset.title;
      }
      root.querySelector('[data-order-image-kind]').textContent = messages[kind];
      root.querySelector('[data-order-image-title]').textContent = input.dataset.title;
    };
    const updateSelections = () => {
      let total = 0;
      kinds.forEach(kind => {
        const input = selected(kind);
        if (!input) return;
        total += Number(input.dataset.price) || 0;
        root.querySelector(`[data-order-summary="${kind}"]`).textContent = input.dataset.title;
        const preview = root.querySelector(`[data-order-preview-kind="${kind}"]`);
        preview.querySelector('[data-order-preview-title]').textContent = input.dataset.title;
        const previewImage = preview.querySelector('img');
        if (input.dataset.image) {
          const previewUrl = new URL(input.dataset.image, location.origin);
          previewUrl.searchParams.set('width', '180');
          previewImage.src = previewUrl.href;
          previewImage.alt = input.dataset.title;
        }
      });
      prices.forEach(node => { node.textContent = money(total); });
    };
    const updateButtons = () => {
      const locked = busy || uncertain;
      choices.forEach(input => { input.disabled = locked || input.dataset.available !== 'true'; });
      root.querySelectorAll('[data-order-go]').forEach(button => { button.disabled = locked || Number(button.dataset.orderGo) > maxReached + 1 || (Number(button.dataset.orderGo) > 0 && !valid('tumbler')); });
      root.querySelectorAll('[data-order-preview-kind]').forEach(button => { button.disabled = locked; });
      next.disabled = locked || !valid('tumbler') || (step === 1 && !validSet());
      back.disabled = locked;
      submit.disabled = locked || !validSet();
      recover.disabled = busy;
      form.setAttribute('aria-busy', String(busy));
      if (submitLabel) submitLabel.textContent = busy ? messages.busy : config.checkoutLabel;
    };
    const renderStep = (to, scroll = false) => {
      step = to;
      root.dataset.orderStep = String(to);
      root.querySelectorAll('[data-order-stage]').forEach(node => { node.hidden = Number(node.dataset.orderStage) !== to; });
      root.querySelectorAll('.wlo-progress [data-order-go]').forEach(button => {
        button.dataset.complete = String(Number(button.dataset.orderGo) < maxReached);
        if (Number(button.dataset.orderGo) === to) button.setAttribute('aria-current', 'step');
        else button.removeAttribute('aria-current');
      });
      root.querySelector('[data-order-title]').textContent = messages[`step_title_${to}`];
      root.querySelector('[data-order-intro]').textContent = messages[`step_text_${to}`];
      root.querySelector('[data-order-count]').textContent = `${to + 1} / 3. ${messages.step_count}`;
      back.hidden = to === 0;
      next.hidden = to === 2;
      submit.hidden = to !== 2;
      updateSelections();
      updateImage(to === 1 ? 'base' : 'tumbler');
      updateButtons();
      if (builderOpened) track('builder_step_viewed', { step: to + 1 }, `viewed:${to + 1}`);
      if (scroll) {
        heading.focus({ preventScroll: true });
        const target = innerWidth < 750 ? root.querySelector('.wlo-grid') : root;
        window.scrollTo({ top: Math.max(0, scrollY + target.getBoundingClientRect().top - 16), behavior: reduced.matches ? 'instant' : 'smooth' });
        const pane = root.querySelector(`[data-order-stage="${to}"]`);
        if (!reduced.matches && pane.animate) pane.animate([{ opacity: 0, transform: 'translateX(18px)' }, { opacity: 1, transform: 'translateX(0)' }], { duration: 280, easing: 'ease-out' });
      }
    };
    const go = to => {
      if (busy || uncertain || to < 0 || to > 2 || to > maxReached + 1) return;
      openBuilder();
      if ((to > 0 && !valid('tumbler')) || (to > 1 && !validSet())) { showError(messages.missing); track('builder_error', { code: 'missing_selection', step: step + 1 }, `error:missing:${step}`); return; }
      showError('');
      for (let completed = step + 1; completed <= to; completed++) track('builder_step_completed', { step: completed }, `completed:${completed}`);
      maxReached = Math.max(maxReached, to);
      renderStep(to, true);
    };
    const readCart = async () => {
      const response = await request(urls.cart, { headers: { Accept: 'application/json' }, cache: 'no-store', credentials: 'same-origin' });
      if (!response.ok) throw Error('Cart unavailable');
      const cart = await response.json();
      if (!Array.isArray(cart.items)) throw Error('Invalid cart response');
      return cart;
    };
    const operationLines = (cart, operation) => cart.items.filter(line => line.properties?._bullora_landing_set === operation.key);
    const complete = (lines, operation) => lines.length === 3 && operation.ids.every(id => lines.some(line => String(line.variant_id || line.id) === id && line.quantity === 1));
    const confirmed = operation => {
      track('set_added_to_cart', { operation_id: operation.key, variant_ids: operation.ids, quantity: 1 }, `cart:${operation.key}`);
      track('checkout_redirected', { operation_id: operation.key, variant_ids: operation.ids }, `checkout:${operation.key}`);
      storePending(null);
      uncertain = false;
      busy = true;
      updateButtons();
      showError('');
      root.querySelector('.wlo-actions').hidden = true;
      recover.hidden = true;
      cartLink.hidden = false;
      checkoutLink.hidden = false;
      root.querySelector('[data-order-intro]').textContent = messages.confirmed;
      window.location.assign(urls.checkout);
    };
    const reconcile = async (operation, failureMessage) => {
      try {
        let cart = await readCart();
        let lines = operationLines(cart, operation);
        if (complete(lines, operation)) { confirmed(operation); return; }
        if (operation.responseKnown !== true) throw Error('Add result not yet known');
        if (lines.length) track('builder_error', { code: 'partial_set', step: 3, operation_id: operation.key }, `error:partial:${operation.key}`);
        for (let attempt = 0; lines.length && attempt < 4; attempt++) {
          const response = await request(urls.change, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: lines[0].key, quantity: 0 }) });
          if (!response.ok) throw Error('Partial set could not be removed');
          cart = await readCart();
          lines = operationLines(cart, operation);
        }
        if (lines.length) throw Error('Unresolved set');
        storePending(null);
        uncertain = false;
        busy = false;
        recover.hidden = true;
        cartLink.hidden = true;
        updateButtons();
        showError(failureMessage || messages.failed);
        track('builder_error', { code: failureMessage === messages.stock ? 'inventory_unavailable' : 'set_not_added', step: 3, operation_id: operation.key }, `error:add:${operation.key}`);
      } catch {
        track('builder_error', { code: 'cart_verification_pending', step: 3, operation_id: operation.key }, `error:verify:${operation.key}`);
        busy = false;
        uncertain = true;
        recover.hidden = false;
        cartLink.hidden = false;
        updateButtons();
        showError(messages.uncertain);
      }
    };
    const onSubmit = async event => {
      event.preventDefault();
      if (busy || uncertain) return;
      if (step !== 2) { go(step + 1); return; }
      if (!validSet()) { showError(messages.missing); return; }
      const inputs = kinds.map(selected);
      const suffix = globalThis.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`;
      const operation = { key: `bll-${suffix}`, ids: inputs.map(input => input.value), productId: config.productId, responseKnown: false };
      const items = inputs.map((input, index) => ({
        id: input.value, quantity: 1,
        properties: { _bullora_landing_set: operation.key, _bullora_part: kinds[index], ...(index === 0 ? { [messages.base]: inputs[1].dataset.title, [messages.cap]: inputs[2].dataset.title } : {}) }
      }));
      storePending(operation);
      busy = true;
      updateButtons();
      showError('');
      let failureMessage = messages.failed;
      try {
        const response = await request(urls.add, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify({ items }) });
        operation.responseKnown = true;
        storePending(operation);
        if (response.status === 422) failureMessage = messages.stock;
      } catch { track('builder_error', { code: 'add_response_missing', step: 3, operation_id: operation.key }, `error:response:${operation.key}`); }
      await reconcile(operation, failureMessage);
    };
    const onClick = event => {
      const button = event.target.closest('button');
      if (!button || !root.contains(button)) return;
      if (button.hasAttribute('data-order-go')) go(Number(button.dataset.orderGo));
      if (button.hasAttribute('data-order-next')) go(step + 1);
      if (button.hasAttribute('data-order-back')) go(step - 1);
      if (button.hasAttribute('data-order-preview-kind')) {
        const kind = button.dataset.orderPreviewKind;
        go(kind === 'tumbler' ? 0 : 1);
        updateImage(kind);
      }
      if (button.hasAttribute('data-order-recover') && pending && !busy) {
        busy = true;
        updateButtons();
        reconcile(pending, messages.failed);
      }
    };
    const onChange = event => {
      if (!event.target.matches('[data-order-choice]') || busy || uncertain) return;
      openBuilder();
      showError('');
      updateSelections();
      updateImage(event.target.dataset.kind);
      updateButtons();
    };
    root.dataset.orderReady = 'true';
    if (startup) startup.hidden = true;
    root.querySelector('[data-order-progress]').hidden = false;
    root.querySelector('[data-order-preview]').hidden = false;
    form.addEventListener('submit', onSubmit);
    root.addEventListener('click', onClick);
    root.addEventListener('change', onChange);
    renderStep(0);
    if (!kinds.every(kind => choices.some(input => input.dataset.kind === kind && input.dataset.available === 'true'))) {
      showError(messages.unavailable);
      track('builder_error', { code: 'no_available_options', step: 1 }, 'error:options');
    }
    const imageFailed = () => { image.hidden = true; if (imageError) imageError.hidden = false; track('builder_error', { code: 'image_unavailable', step: step + 1 }, `error:image:${selected('tumbler')?.value || 'media'}`); };
    const imageLoaded = () => { if (imageError) imageError.hidden = true; };
    image?.addEventListener('error', imageFailed);
    image?.addEventListener('load', imageLoaded);
    const landing = root.closest('[data-wl-landing]');
    const openLink = event => { if (event.target.closest('[data-wl-build-link]')) openBuilder(); };
    landing?.addEventListener('click', openLink);
    root.addEventListener('focusin', openBuilder);
    let visibilityObserver;
    if ('IntersectionObserver' in window) {
      visibilityObserver = new IntersectionObserver(entries => { if (entries.some(entry => entry.isIntersecting)) openBuilder(); }, { threshold: .08 });
      visibilityObserver.observe(root);
    }
    try {
      const restored = JSON.parse(sessionStorage.getItem(storageKey));
      if (restored && restored.productId === config.productId && /^bll-[a-zA-Z0-9-]+$/.test(restored.key) && Array.isArray(restored.ids) && restored.ids.length === 3 && restored.ids.every(id => choices.some(input => input.value === id))) {
        restored.ids.forEach(id => { choices.find(input => input.value === id).checked = true; });
        pending = restored;
        busy = true;
        maxReached = 2;
        renderStep(2);
        reconcile(restored, messages.failed);
      }
    } catch {}
    root.orderCleanup = () => {
      disposed = true;
      clearInterval(analyticsTimer);
      visibilityObserver?.disconnect();
      document.removeEventListener('visitorConsentCollected', consentChanged);
      landing?.removeEventListener('click', openLink);
      root.removeEventListener('focusin', openBuilder);
      image?.removeEventListener('error', imageFailed);
      image?.removeEventListener('load', imageLoaded);
      form.removeEventListener('submit', onSubmit);
      root.removeEventListener('click', onClick);
      root.removeEventListener('change', onChange);
      delete root.dataset.orderReady;
    };
  };
  const scan = (scope = document) => scope.querySelectorAll('[data-wl-order]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(), { once: true });
  else scan();
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-wl-order]').forEach(root => root.orderCleanup?.()));
})();

